<vwui-header>
    <h2 a11yPageTitleLevel="1">{{ "PAGE_OPPORTUNITY_LIBRARY.title" | translate}}</h2>
</vwui-header>

<vwui-spinner *ngIf="loadingSpinnerService.isSpinnerVisible()"></vwui-spinner>

<div class="mt-lg" *ngIf="!loadingSpinnerService.isSpinnerVisible()">
    <app-library-mgmt [library]="opportunitiesLibrary" [companyTypeId]="companyTypeId">
    </app-library-mgmt>
</div>
